export function parseNotificationCount(value) {
  const count = Number(value)
  return Number.isFinite(count) ? count : 0
}

export function sortNotificationsNewestFirst(notifications) {
  if (!Array.isArray(notifications)) return []
  return [...notifications].sort((a, b) => {
    const aTime = Date.parse(a && a.timestamp) || 0
    const bTime = Date.parse(b && b.timestamp) || 0
    if (aTime !== bTime) return bTime - aTime
    return (Number(b && b.id) || 0) - (Number(a && a.id) || 0)
  })
}
